import axios from './axios';

const MenuSetting = {
    getMenuCourse: async (restaurant_id) => {
        try {
            const response = await axios.get(`/meal-courses`);
            return response.data.data;
        } catch(e) {
            console.error(e);
        }
    },
    saveMenuCourse: async (data) => {
        try {
            const response = await axios.post(`/meal-courses`, data);
            return response.data.data;
        } catch(e) {
            console.error(e);
        } 
    },
    updateMenuCourse: async (menuItem,id) => {
        try {
            const response = await axios.put(`/meal-courses/${id}`, menuItem);
            return response.data.data;
        } catch(e) {
            console.error(e);
        } 
    },
    deleteMenuCourse: async(id) => {
        try {
            const response = await axios.delete(`/meal-courses/${id}`);
            return response.data.data;
        } catch(e) {
            console.error(e);
        } 
    },
    getRestaurentSettings: async (restaurant_id) => {
        try {
            const response = await axios.get(`/restaurant-settings`);
            return response.data.data;
        } catch(e) {
            console.error(e);
        }
    },
    saveRestaurentSettings: async (data) => {
        try {
            const response = await axios.put(`/restaurant-settings`, data);
            return response.data.data;
        } catch(e) {
            console.error(e);
        } 
    },
};

export default MenuSetting;